<template>
  <section class="admin-content" id="forecasts">
    <Navbar />
    <main class="admin-main">
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0;">
            <div class="header-icon-wrap mr-3"><i class="fe fe-activity" style="font-size: 22px;"></i></div>
            <div>
              <h4 class="mb-0 font-weight-bold">Forecasts</h4>
              <small style="opacity: 0.8;">Utilization, claims and enrolment for the coming months, from the agency's monthly history</small>
            </div>
          </div>
        </div>
      </div>
      <section style="margin-top: -20px;">
        <div class="container pb-5">
          <ul class="nav nav-tabs page-tabs mb-3">
            <li class="nav-item"><a href="#" class="nav-link" :class="{ active: tab === 'forecasts' }" @click.prevent="setTab('forecasts')"><i class="fe fe-activity mr-1"></i> Forecasts</a></li>
            <li class="nav-item"><a href="#" class="nav-link" :class="{ active: tab === 'targets' }" @click.prevent="setTab('targets')"><i class="fe fe-target mr-1"></i> Targets</a></li>
          </ul>
          <div v-if="tab === 'forecasts'" class="row">
            <div class="col-lg-6" v-for="m in metrics" :key="m"><ForecastPanel :fixed-metric="m" compact /></div>
          </div>
          <TargetsPanel v-else />
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import ForecastPanel from "./components/ForecastPanel.vue";
import TargetsPanel from "./components/TargetsPanel.vue";

export default {
  components: { Navbar, ForecastPanel, TargetsPanel },
  data() {
    return { metrics: ["encounters", "claims", "claims_amount", "enrollment", "authorization_codes"], tab: this.$route.query.tab === "targets" ? "targets" : "forecasts" };
  },
  methods: {
    setTab(t) {
      this.tab = t;
      if (this.$route.query.tab !== t) this.$router.replace({ query: { ...this.$route.query, tab: t } }).catch(() => {});
    },
  },
};
</script>

<style scoped>
@import "../reports/reports.css";
.page-tabs { background: #fff; border-radius: 8px; padding: 6px 8px 0; box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08); }
.page-tabs .nav-link { color: #475569; font-weight: 600; }
.page-tabs .nav-link.active { color: #1f6feb; }
</style>
